import { Box, Skeleton } from '@mui/material'
import { FC } from 'react'

const SIZES = {
  sm: '2.4rem',
  md: '4rem',
}

const BORDER_RADIUS = {
  sm: '0.4rem',
  md: '0.8rem',
}

export interface IntegrationLogoProps {
  logoUrl?: string
  name: string
  size?: 'sm' | 'md'
}

export const IntegrationLogo: FC<IntegrationLogoProps> = ({
  logoUrl,
  name,
  size = 'md',
}) => {
  const dimension = SIZES[size]
  const borderRadius = BORDER_RADIUS[size]

  if (logoUrl) {
    return (
      <Box
        component="img"
        src={logoUrl}
        alt={name}
        sx={{
          width: dimension,
          height: dimension,
          objectFit: 'contain',
          borderRadius,
        }}
      />
    )
  }

  return (
    <Skeleton
      variant="rounded"
      width={dimension}
      height={dimension}
      sx={{ borderRadius }}
    />
  )
}
